import { useState } from "react";
import AuthLayout from "../../components/layouts/auth";
import { strReplace } from "../../lib/helper-support";
import SelectField from "../../components/form/select-field";
import { useServiceStatus } from "../../composables/business-merchant/useServiceStatus";

export default function ServiceStatus() {
  const [currentService, setCurrentService] = useState<string>("bank_transfer");

  const services = [
    "bank_transfer",
    "airtime",
    "internet_data",
    "electricity",
    "tv",
  ];

  const { data } = useServiceStatus({
    category: currentService,
  });

  const getColorClass = (successRate: string) => {
    const rate = Number(successRate);
    if (rate < 30) {
      return "text-red-500";
    } else if (rate < 70) {
      return "text-yellow-500";
    } else {
      return "text-green-500";
    }
    }

  return (
    <AuthLayout>
      <div>
        <h1 className="page-title">Service Status</h1>
        <div className="mt-10">
          <h3 className="text-[#2E384D] font-[700] text-[20px] mb-5">
            View Service Status:{" "}
            <span className="text-primary uppercase">
              {strReplace(currentService, "_", " ")}
            </span>
          </h3>
          <SelectField
            label="Select Service"
            options={services.map((service) => ({
              value: service,
              name: strReplace(service, "_", " "),
            }))}
            value={currentService}
            onChangeInput={setCurrentService}
          />
          <div className="flex flex-wrap gap-5 mt-5">
            {data?.map((item: {provider_name: string, success_rate: string}) => (
              <div className="flex items-center rounded-full border border-gray-200 px-5 py-2 gap-2">
                <span className="uppercase label">{item.provider_name}</span>
                <span className={`font-bold text-sm ${getColorClass(item.success_rate)}`}>{item.success_rate}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
